import { FC } from 'react';

import cn from 'classnames';

import { Switch } from '@mui/material';

import './oSwitch.scss';

interface IProps {
  label?: string;
  sectionTitle?: string;
  isChecked?: boolean;
  isDisabled?: boolean;
  variant?: 'primary' | 'alternative';
  size?: 'small' | 'medium' | 'large' | 'full' | 'fit';
  onChange?: (checked: boolean) => void;
  classes?: {
    container?: string;
    label?: string;
    border?: 'none';
    alignment?: 'left';
  };
  id?: string;
}

const OSwitch: FC<IProps> = ({
  label,
  sectionTitle,
  size = 'large',
  variant = 'alternative',
  isChecked,
  isDisabled,
  onChange,
  classes,
  id,
}) => {
  return (
    <div className={cn('o-switch-container', size)}>
      {sectionTitle && <div className="switch-title">{sectionTitle}</div>}
      <div
        className={cn(
          'switch-label-container',
          classes?.label,
          classes?.alignment,
          classes?.container,
          classes?.border
        )}
      >
        <label className="switch-label" id={id ? id : ''}>
          {label ? label : ''}
        </label>

        <Switch
          disabled={isDisabled}
          checked={isChecked}
          onChange={(e) => onChange?.(e.target.checked)}
          color="default"
          classes={{
            root: 'switch-root',
            thumb: 'switch-thumb',
            track: variant === 'primary' ? 'switch-track-primary' : 'switch-track',
            switchBase: 'switch-base',
            checked: 'checked-switch',
            disabled: 'switch-disabled',
          }}
        />
      </div>
    </div>
  );
};

export default OSwitch;
